document.addEventListener("DOMContentLoaded", function () {
  const trigger = document.querySelectorAll(".js-accordionTrigger");

  if (trigger && trigger.length) {
    trigger.forEach(function (accordionButton) {
      const accordionId = accordionButton.getAttribute("aria-controls");
      const accordionContainer = document.querySelector("#" + accordionId);

      if (accordionButton.classList.contains("expanded")) {
        expandAccordion(accordionContainer, accordionButton);
      }

      accordionButton.addEventListener("click", function () {
        if (accordionContainer) {
          if (accordionButton.classList.contains("expanded")) {
            accordionButton.classList.remove("expanded");
            accordionContainer.style.maxHeight = "";
          } else {
            expandAccordion(accordionContainer, accordionButton);
          }
        }
      });
    });
  }

  function expandAccordion(accordionContainer, accordionButton) {
    accordionButton.classList.add("expanded");
    accordionContainer.style.maxHeight = accordionContainer.scrollHeight + "px";
  }
});
